import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { MockedProvider } from '@apollo/client/testing';
import { FormCommonProvider } from '@isyc-react/form/modules/context/form-common';
import { AuthProvider } from '@isyc-react/auth/modules/context';
import { Router } from 'core/router';
import { FormSize } from '@isyc-react/form';
import { NotificationHubProvider } from '@isyc-react/form/modules/context/notification-hub';
import { ApolloMockLink } from 'common/api/mocks/apollo';
import { ApolloClient } from '@isyc-react/oc-api';
import './i18n/i18n';
import 'assets/css/font-montserrat.css';
import '@isyc-react/design/main';
import 'assets/scss/portal.scss';
import 'assets/scss/buttons.scss';
import 'core/theme/variables.scss';
const SuspenseRouter = () => (React.createElement(React.Suspense, { fallback: React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center justify-content-center h-100' },
            React.createElement("div", { className: 'spinner-border text-secondary', role: 'status', style: { width: '40px', height: '40px' } },
                React.createElement("span", { className: 'visually-hidden' }, "Loading...")))) },
    React.createElement(AuthProvider, { checkLoggedIn: true },
        React.createElement(NotificationHubProvider, null,
            React.createElement(FormCommonProvider, { size: FormSize.LG },
                React.createElement(Router, null))))));
const App = () => {
    if (process.env.NODE_ENV === 'development' && process.env.mocks === 'true') {
        return (React.createElement(MockedProvider, { link: ApolloMockLink },
            React.createElement(SuspenseRouter, null)));
    }
    return (React.createElement(ApolloProvider, { client: ApolloClient },
        React.createElement(SuspenseRouter, null)));
};
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
